(function(){
  if(window.__tokePolish) return; window.__tokePolish=true;

  // 1) Scroll reveal en secciones de la home
  var sels = ['.tkbr','.tkpr','.tkps','.tkcf','.tkn','.tkr','.tke','.tknv','.tkcat','.tkw','.tknl','.tkg','.tkig'];
  function reveal(){
    var els = [];
    sels.forEach(function(s){ document.querySelectorAll(s).forEach(function(el){ if(els.indexOf(el)<0) els.push(el); }); });
    if(!('IntersectionObserver' in window)){ els.forEach(function(el){ el.classList.add('toke-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('toke-in'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function(el){ el.classList.add('toke-reveal'); io.observe(el); });
  }

  // 2) Pastilla peach en el item ‘Ofertas’ del menú
  function navPill(){
    var links = document.querySelectorAll('.menu-list__link, .menu-list__item');
    links.forEach(function(a){
      var t = (a.textContent || '').trim().toLowerCase();
      if(t === 'ofertas' || t === 'sale' || t === 'rebajas'){
        var li = a.closest('.menu-list__list-item') || a;
        li.classList.add('toke-navpill');
      }
    });
  }

  function run(){ reveal(); navPill(); }
  if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', function(){ setTimeout(navPill, 150); });
})();
